import 'intersection-observer';

const intersectionCallback = (entries) => {
  entries.forEach(entry => {
    const targetId = entry.target.getAttribute('data-hint');
    const targetNode = document.querySelector(`#hint-${targetId}`);
    const panelNode = targetNode.closest('.sticky-panel');

    if (entry.intersectionRatio > 0) {
      entry.target.classList.add('form-group_visible');
      targetNode.classList.add('hint-paragraph_visible');
      panelNode.classList.add('sticky-panel_visible');
    } else {
      entry.target.classList.remove('form-group_visible');
      targetNode.classList.remove('hint-paragraph_visible');

      if (panelNode.querySelectorAll('.hint-paragraph_visible').length == 0) {
        panelNode.classList.remove('sticky-panel_visible');
      }
    }
  });
}

const intersectionOptions = { rootMargin: '-25% 0px -70% 0px' };
const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);

const init = () => {
  const el = document.querySelector('.form-with-sticky-panel');
  if (!el) return;
  const nodes = el.querySelectorAll('[data-hint]');
  Array.from(nodes).forEach(node => observer.observe(node));
};

const start = () => {
  document.addEventListener('page:load', init);
};

export default { start };
